export const RAZOR_SETTINGS_FETCH_SUCCESSFUL = 'RAZOR_SETTINGS_FETCH_SUCCESSFUL';
export const BANKLIST_FETCH_SUCCESSFUL = 'BANKLIST_FETCH_SUCCESSFUL';
